import { Routes, Route } from 'react-router-dom';
import { useState, useEffect } from 'react';
import HomePage from '@kidstube/pages/HomePage';
import WatchPage from '@kidstube/pages/WatchPage';
import ParentDashboard from '@kidstube/pages/ParentDashboard';
import Layout from '@kidstube/components/Layout';
import LoginPage from '@kidstube/pages/LoginPage';
import type { UserInfo } from '@kidstube/types';
import { apiFetch } from '@kidstube/lib/api';

export default function App() {
  const [user, setUser] = useState<UserInfo | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiFetch<UserInfo>('/api/auth/me')
      .then((data) => {
        setUser(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="loading-logo">🎬</div>
        <div className="loading-text">Loading KidsTube...</div>
      </div>
    );
  }

  if (!user) {
    return <LoginPage />;
  }

  return (
    <Layout user={user}>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/watch/:videoId" element={<WatchPage />} />
        <Route path="/channel/:channelId" element={<HomePage />} />
        {user.isParent && <Route path="/parent/*" element={<ParentDashboard />} />}
      </Routes>
    </Layout>
  );
}
